<template>
  <b-row class="justify-content-center m-0 mt-u6" align-v="center" :style="{ height: '100%' }">
    <div>
      <b-col class="box-outer-content">
        <b-row><b-img class="img-left-s mb-u4" :src="require(`@/assets/4life-logo.png`)" /></b-row>
        <b-row class="box-content">
          <b-col class="box-content__left">
            <div class="content">
              <b-img class="img-left-l mb-u4" :src="require(`@/assets/4life-logo.png`)" />
              <div class="mb-u6 text__title">
                <h3><b>We encountered an error while processing your email address update.</b></h3>
              </div>
              <span class="text__description"
                ><span>Please contact our support team at </span
                ><a href="https://support.4lifelonglearning.org/hc/th">4Life support</a>
                <span> for further assistance. We apologize for the inconvenience. </span>
              </span>
              <span class="text__email text-primary" variant="primary">{{ email }}</span>
            </div>
          </b-col>
          <b-col cols="4" class="box-content__right">
            <b-img class="img-right" :src="require(`@/assets/warning-sign.jpg`)" />
          </b-col>
        </b-row>
      </b-col>
    </div>
  </b-row>
</template>

<script>
export default {
  methods: {
    async goToSignIn() {
      this.$router.push({ name: 'SignIn' });
    }
  }
};
</script>

<style lang="scss" scoped>
.text__title {
  font-family: Heebo;
  font-size: 36px;
  font-weight: 700;
  line-height: 22.8px;
  width: 100%;
  color: #3b3e66;
}

.text__description {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
  color: #3b3e66;
}
.text__email {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
}
.box-outer-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.box-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 50px 10px;
  padding: 5%;
}
.box-content__right .img-right {
  max-width: 300px;
}
.img-left-l {
  max-width: 180px;
}
.img-left-s {
  max-width: 180px;
  display: none;
}
a {
  text-decoration: underline;
}
@media only screen and (max-width: 767px) {
  .box-content {
    flex-direction: column-reverse;
    gap: 10px 15px;
    padding: 0;
    width: 100%;
  }
  .box-content__right {
    min-width: 300px;
    width: 80%;
  }
  .img-right {
    width: 100%;
  }
  .box-content__left {
    align-items: center;
    min-width: 100px;
    width: 90%;
  }
  .content {
    text-align: center;
  }
  .box-outer-content {
    align-items: center;
  }
  .img-left-l {
    display: none;
    max-width: 180px;
  }
  .img-left-s {
    display: block;
    max-width: 180px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .box-content {
    gap: 50px 0;
  }
  .box-content__right .img-right {
    min-width: 250px;
    width: 100%;
  }
}
</style>
